import { render, staticRenderFns } from "./ViewApplicationPage.vue?vue&type=template&id=198e6158&scoped=true"
import script from "./ViewApplicationPage.vue?vue&type=script&lang=js"
export * from "./ViewApplicationPage.vue?vue&type=script&lang=js"
import style0 from "./ViewApplicationPage.vue?vue&type=style&index=0&id=198e6158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198e6158",
  null
  
)

export default component.exports